import template from './unauthenticated-header.component.html';
import controller from './unauthenticated-header.controller';

const unauthenticatedHeader = {
  template,
  controller,
};

export default unauthenticatedHeader;
